import { render, staticRenderFns } from "./wxEditor.vue?vue&type=template&id=cea9e31c&scoped=true&"
import script from "./wxEditor.vue?vue&type=script&lang=js&"
export * from "./wxEditor.vue?vue&type=script&lang=js&"
import style0 from "./wxEditor.vue?vue&type=style&index=0&id=cea9e31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea9e31c",
  null
  
)

export default component.exports